jQuery(function () {
	jQuery('.si-slick').slick({
		prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20.247" height="32.255" viewBox="0 0 20.247 32.255"> <path id="Path_1242" data-name="Path 1242" d="M-7463.754-3801.016l15.758-16.961,14.25,16.961" transform="translate(3820.241 -7432.598) rotate(-90)" fill="none" stroke="#fff" stroke-width="3"/> </svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20.247" height="32.255" viewBox="0 0 20.247 32.255"><path id="Path_1235" data-name="Path 1235" d="M-7463.754-3801.016l15.758-16.961,14.25,16.961" transform="translate(-3799.995 7464.854) rotate(90)" fill="none" stroke="#fff" stroke-width="3"/> </svg></button>',
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	jQuery('.slick-arrow').parent().addClass('has-arrows');
});

